import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

import { ApiConfig } from '../../shared/config/api.config';
import {
    BusinessService,
    TreeService,
    BreadcrumbService,
} from '../../shared/services';

@Component({
    selector: 'app-terminal-lookup',
    templateUrl: './terminal-lookup.component.html',
    styleUrls: ['./terminal-lookup.component.scss'],
})
export class TerminalLookupComponent implements OnInit {
    private readonly SERIAL_PATTERN = /^[a-zA-Z0-9]{8,20}$/;

    serialInput: string = '';
    isLoading: boolean = false;
    searchPerformed: boolean = false;

    terminalInfo: any = null;
    storeInfo: any = null;
    businessInfo: any = null;
    profitCenterInfo: any = null;

    errorMessage: string = '';

    constructor(
        private router: Router,
        private http: HttpClient,
        private apiConfig: ApiConfig,
        private businessService: BusinessService,
        private treeService: TreeService,
        private breadcrumbService: BreadcrumbService,
    ) {}

    ngOnInit(): void {
        this.setBreadcrumb();
    }

    setBreadcrumb(): void {
        const breadCrumb: any = {};
        breadCrumb.root = 'Terminal# Lookup';
        breadCrumb.child = '';
        breadCrumb.subChild = '';
        breadCrumb.subChildLink = null;
        breadCrumb.grandChild = '';
        breadCrumb.rootList = [];
        this.breadcrumbService.setBreadCrumb(breadCrumb);
    }

    search(): void {
        const serial = this.serialInput.trim();
        if (!serial) {
            this.errorMessage = 'Please enter a Serial Number to search.';
            return;
        }
        if (!this.SERIAL_PATTERN.test(serial)) {
            this.errorMessage = 'Serial Number must be 8�C20 alphanumeric characters (letters and digits only).';
            return;
        }

        this.isLoading = true;
        this.searchPerformed = false;
        this.terminalInfo = null;
        this.storeInfo = null;
        this.businessInfo = null;
        this.profitCenterInfo = null;
        this.errorMessage = '';

        const url = `${this.apiConfig.API_HOST}/api/terminal-lookup-by-ser-num`;
        this.http.get(url, { params: { xRegSerNum: serial } }).subscribe(
            (response: any) => {
                this.isLoading = false;
                this.searchPerformed = true;
                if (response?.found && response.data) {
                    const { xbcBusiness, xbcStore, xbcPCtr, ...terminalFields } = response.data;
                    this.terminalInfo = terminalFields;
                    this.storeInfo = xbcStore || null;
                    this.businessInfo = xbcBusiness || null;
                    this.profitCenterInfo = xbcPCtr || null;
                    if (this.terminalInfo.xBusinessID) {
                        this.businessService.setBusinessID(this.terminalInfo.xBusinessID);
                        this.treeService.setId(this.terminalInfo.xBusinessID, 'business');
                    }
                }
            },
            (error: any) => {
                this.isLoading = false;
                this.searchPerformed = true;
                this.errorMessage = error.status === 403
                    ? 'Invalid request: Serial Number is required.'
                    : 'Search failed. Please try again.';
            },
        );
    }

    navigateToBusiness(): void {
        if (!this.terminalInfo?.xBusinessID) return;
        this.businessService.setBusinessID(this.terminalInfo.xBusinessID);
        this.treeService.setId(this.terminalInfo.xBusinessID, 'business');
        this.router.navigate(['/dashboard/setup/business/structure/information', this.terminalInfo.xBusinessID]);
    }

    navigateToStore(): void {
        if (!this.terminalInfo?.xStoreID) return;
        this.businessService.setBusinessID(this.terminalInfo.xBusinessID);
        this.treeService.setId(this.terminalInfo.xStoreID, 'store');
        this.router.navigate(['/dashboard/setup/business/structure/store', this.terminalInfo.xStoreID]);
    }

    navigateToProfitCenter(): void {
        if (!this.terminalInfo?.xMainPCtrID) return;
        this.businessService.setBusinessID(this.terminalInfo.xBusinessID);
        this.treeService.setId(this.terminalInfo.xStoreID, 'store');
        // console.log('this.terminalInfo.xMainPCtrID', this.terminalInfo.xMainPCtrID);
        this.router.navigate(['/dashboard/setup/business/structure/profit-center', this.terminalInfo.xMainPCtrID]);
    }
}
